import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/auth.actions';
import './SessionExpired.css';

const SessionExpired = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  return (
    <div className="session-expired-page">
      <div className="session-expired-orb session-expired-orb-one" />
      <div className="session-expired-orb session-expired-orb-two" />

      <div className="session-expired-card">
        <div className="session-expired-badge">Session Ended</div>
        <h2 className="session-expired-title">Your session has expired</h2>
        <p className="session-expired-message">
          For security reasons, your login session timed out. Please sign in
          again to continue.
        </p>

        <button
          type="button"
          className="session-expired-btn"
          onClick={handleBackToLogin}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default SessionExpired;
